<template lang="pug">
.loader
	span Loading
</template>

<script>
export default {
	name: "Loader"
}
</script>

<style lang="scss" scoped>
.loader {
	height: 80px;
	width: 80px;
	display: flex;
	margin: 2rem auto;
	justify-content: center;
	align-items: center;
	background: red;
	color: white;
	border-radius: 50%;
	animation: pulse 1s infinite;
}
@keyframes pulse {
	0% {
		box-shadow: 0 0 0 rgba(red, 0.5);
	}
	50% {
		box-shadow: 0 0 0 20px rgba(red, 0.5);
	}
	100% {
		box-shadow: 0 0 0 rgba(red, 0.5);
	}
}
</style>
